import React from "react";

import Dialog from "@busbud/design-system-components/dist/Dialog/Dialog";
import DialogContent from "@busbud/design-system-components/dist/DialogContent/DialogContent";
import DialogTitle from "@busbud/design-system-components/dist/DialogTitle/DialogTitle";
import { useTheme } from "@busbud/design-system-components/dist/styles/useTheme";
import { useMediaQuery } from "@busbud/design-system-components/dist/utilities/useMediaQuery";

import { createStyles } from "@app/components/tss/hooks/use-tss-styles";
import { useAppContext } from "@app/helpers/hooks";
import {
  ASYNC_CART_VIEWS,
  getAsyncCartView
} from "@app/modules/async-cart/selectors/get-async-cart-view";
import { SeatSelectionAsyncCartModal } from "@app/modules/results/components/departure/seat-selection-details/container-modal/container-modal-async-cart.connect";
import { SeatSelectionCheckoutModal } from "@app/modules/results/components/departure/seat-selection-details/container-modal/container-modal-checkout.connect";
import { useResultsSelector } from "@app/modules/results/hooks/use-results-selector";
import { closedSeatSelection } from "@app/tracking/checkout-tracking";
import type { Gender } from "@app/types/checkout-types";

interface SeatSelectionV2DialogProps {
  onClose: () => void;
  direction: "outbound" | "return";
  passenger_index?: number;
  onGenderSelect?: (gender: Gender, passenger_index: number) => void;
}

const useStyles = createStyles(({ theme }) => {
  const { spacing } = theme;
  return {
    boxRoot: {
      marginLeft: spacing(1),
      marginRight: spacing(1)
    },
    container: {
      maxHeight: "calc(100vh - 136px)"
    },
    title: {},
    content: {
      overflow: "initial",
      padding: spacing(0, 2)
    }
  };
});

export const SeatSelectionV2Dialog = (props: SeatSelectionV2DialogProps) => {
  const { translator, features, tracker } = useAppContext();
  const { classes } = useStyles();
  const theme = useTheme();
  const is_xs_down = useMediaQuery(theme.busbud.breakpoints.down("xs"), {
    noSsr: true
  });

  const asyn_cart_pageview = useResultsSelector(state =>
    getAsyncCartView(state, "", undefined)
  );

  const SeatSelectionModalComponent =
    asyn_cart_pageview === ASYNC_CART_VIEWS.FULL_FORM_CART_SOURCE
      ? SeatSelectionAsyncCartModal
      : SeatSelectionCheckoutModal;

  const onClose = () => {
    tracker.track(closedSeatSelection());
    props.onClose();
  };

  return (
    <Dialog
      title={translator.t("!results.seat-selection.seat-selection")}
      maxWidth="sm"
      fullScreen={is_xs_down}
      open
      className={classes.container}
      BoxProps={{
        className: classes.boxRoot
      }}
      onClose={onClose}
    >
      {!!features.CHECKOUT_SEAT_SELECTION_V2_SHOULD_SHOW_SEAT_SELECTOR_DRAWER_TITLE && (
        <DialogTitle className={classes.title} onClose={onClose}>
          {translator.t("!checkout.seat-selection.choose")}
        </DialogTitle>
      )}
      <DialogContent className={classes.content}>
        <SeatSelectionModalComponent
          direction={props.direction}
          passenger_index={props.passenger_index}
          onGenderSelect={props.onGenderSelect}
        />
      </DialogContent>
    </Dialog>
  );
};
